import React from "react";

const UnicodeToPreeti = () => {
  return (
    <div className="w-full w-padding">
      <div className="bg-primary-blue mt-10 font-Acme w-[105%] rounded-full p-1 text-center text-2xl font-semibold text-white">
        Unicode to preeti
      </div>
      <iframe
        title="unicode to preeti"
        width="100%"
        height={400}
        frameBorder={0}
        border="no"
        scrolling="no"
        marginWidth={0}
        marginHeight={0}
        allowtransparency="true"
        src="https://www.ashesh.com.np/linknepali-unicode3.php?api=232162m565"
      ></iframe>
    </div>
  );
};

export default UnicodeToPreeti;
